export const getPopupContainer = (elem: HTMLElement): HTMLElement =>
{
	// return elem?.closest?.('[role="document"]') || document.body;
	return elem?.closest?.('[role="document"]') || document?.getElementById?.('root') || document.body;
}
